import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Item = styled(Link)`
  display: flex;
  align-items: center;
  color: inherit;
  text-decoration: none;
  font-weight: 400;
  margin-bottom: 0.05em;
  padding: 0.6em;
  font-size: 1.8rem;

  &:hover,
  &:focus {
    text-decoration: underline;
  }

  svg {
    margin-right: 0.8em;
    height: 1.35em;
    width: 1.35em;
  }
`

export default Item



// WEBPACK FOOTER //
// ./src/components/MenuItem.js